module.exports = __webpack_public_path__ + "img/switch-energy.7246d4c.png";